import React from 'react';
import { DurationInput } from '../DurationInput';

interface DurationRepeatFieldProps {
  value: string;
  onChange: (value: string) => void;
  neverRepeat: boolean;
  onNeverRepeatChange: (value: boolean) => void;
}

export const DurationRepeatField: React.FC<DurationRepeatFieldProps> = ({
  value,
  onChange,
  neverRepeat,
  onNeverRepeatChange,
}) => {
  return (
    <div className="space-y-2">
      <DurationInput
        label="Duration Repeat"
        value={value}
        onChange={onChange}
        disabled={neverRepeat}
        tooltip="How long to wait before repeating the protocol"
      />
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="neverRepeat"
          checked={neverRepeat}
          onChange={(e) => onNeverRepeatChange(e.target.checked)}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <label htmlFor="neverRepeat" className="text-sm text-gray-600">
          Never repeat
        </label>
      </div>
    </div>
  );
};